module.exports = __webpack_public_path__ + "img/chart-icon.0d7976d8.svg";